var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpFlat(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4972 0.00116363L26.9982 13.5021L25.9375 14.5627L12.4366 1.06182L13.4972 0.00116363Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00103259 13.5009L13.4999 8.79169e-06L14.5605 1.06067L1.05963 14.5616L-0.00103259 13.5009Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFlat);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyNyAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjQ5NzIgMC4wMDExNjM2M0wyNi45OTgyIDEzLjUwMjFMMjUuOTM3NSAxNC41NjI3TDEyLjQzNjYgMS4wNjE4MkwxMy40OTcyIDAuMDAxMTYzNjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTS0wLjAwMTAzMjU5IDEzLjUwMDlMMTMuNDk5OSA4Ljc5MTY5ZS0wNkwxNC41NjA1IDEuMDYwNjdMMS4wNTk2MyAxNC41NjE2TC0wLjAwMTAzMjU5IDEzLjUwMDlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { ForwardRef as ReactComponent };